// assets/nd-cart-hide-uuid.js (v1)
// Goal: Hide "uuid: xxxx" line item property display on cart UI (do NOT delete data)

(function () {
  if (window.__ND_CART_HIDE_UUID_V1__) return;
  window.__ND_CART_HIDE_UUID_V1__ = true;

  function isCart() {
    try { return (location.pathname || "").toLowerCase().indexOf("/cart") === 0; }
    catch (e) { return false; }
  }
  if (!isCart()) return;

  function normalize(s) {
    return String(s || "")
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function shouldHideText(t) {
    t = normalize(t);
    // match "uuid: xxxx" or "uuid : xxxx"
    if (t.indexOf("uuid:") === 0) return true;
    if (t.indexOf("uuid :") === 0) return true;
    return false;
  }

  function hideUuidLines() {
    try {
      // Cover common Dawn/cart markup variations:
      // dd / dt pairs, li entries, small/p spans, etc.
      var nodes = document.querySelectorAll("dd, dt, li, p, small, span, div");
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var t = el && el.textContent ? el.textContent : "";
        if (!t) continue;

        if (shouldHideText(t)) {
          // Hide this node
          try { el.style.display = "none"; } catch (e1) {}

          // If it's a <dt> "uuid", hide paired <dd> (or vice versa)
          try {
            var tag = (el.tagName || "").toLowerCase();
            if (tag === "dt") {
              var dd = el.nextElementSibling;
              if (dd && (dd.tagName || "").toLowerCase() === "dd") dd.style.display = "none";
            }
            if (tag === "dd") {
              var dt = el.previousElementSibling;
              if (dt && (dt.tagName || "").toLowerCase() === "dt") dt.style.display = "none";
            }
          } catch (e2) {}
        }
      }
    } catch (e) {}
  }

  // run a few times (cart can re-render)
  hideUuidLines();
  setTimeout(hideUuidLines, 300);
  setTimeout(hideUuidLines, 900);
  setTimeout(hideUuidLines, 1800);

  // Also observe DOM changes (safer with dynamic cart updates)
  try {
    var mo = new MutationObserver(function () { hideUuidLines(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e3) {}
})();
